import { createContext, useContext } from 'react';

const IsNextEnvContext = createContext(false);
const useIsNextEnv = () => {
    return useContext(IsNextEnvContext);
};

export { IsNextEnvContext, useIsNextEnv as default, useIsNextEnv };
//# sourceMappingURL=useIsNextEnv.js.map
